import { useSelector } from 'react-redux';

import { H4, SectionBody } from '@portal/common/components';
import { CroRecords } from '@portal/common/models/data-type';
import { styled } from '@portal/common/theme';

import _ from '../../locale';
import { getSelectedConditionsDataTypes } from '../../store/data-explorer/selectors';

const StyledSectionBody = styled(SectionBody)(({ theme }) => ({
    padding: '12px 20px !important',
    transition: 'box-shadow 0.2s ease-in-out',
    ':hover': {
        boxShadow: '0 4px 9px 0 rgba(0, 0, 0, 0.10)',
    },
    '& svg': {
        fill: `${theme.color.gray40} !important`,
        '& path': {
            fill: `${theme.color.gray40} !important`,
        },
    },
    ':hover svg': {
        fill: `${theme.color.green1} !important`,
        '& path': {
            fill: `${theme.color.green1} !important`,
        },
    },
}));

const Title = styled(H4)({
    fontSize: '2rem',
    lineHeight: '2.4rem',
});

const GranularResolutionMethodologyInfoSection = () => {
    const selectedDataTypes = useSelector(getSelectedConditionsDataTypes);

    if (!selectedDataTypes?.includes(CroRecords)) {
        return null;
    }

    return (
        <StyledSectionBody
            id="granular-resolution-methodology-info"
            isCollapsible
            isCollapsedInitially={false}
            title={<Title>{_('granular_resolution_methodology_info_title')}</Title>}
        >
            {_('granular_resolution_methodology_info_description')}
        </StyledSectionBody>
    );
};

export default GranularResolutionMethodologyInfoSection;
